export const initialState = {
    searchResult: [],
    searchText: "",
    loaderLoading: false,
    documentSearchHeaders: []

};

const state = { ...initialState };

export default state;